import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "dot"]
  static values = { interval: Number }

  connect() {
    this.currentIndex = 0
    this.intervalValue = this.intervalValue || 5000
    this.startAutoplay()
  }

  disconnect() {
    this.stopAutoplay()
  }

  startAutoplay() {
    this.stopAutoplay()
    if (this.slideTargets.length > 1) {
      this.autoplayTimer = setInterval(() => {
        this.nextSlide()
      }, this.intervalValue)
    }
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer)
      this.autoplayTimer = null
    }
  }

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.slideTargets.length
    this.showSlide(this.currentIndex)
  }

  previousSlide() {
    this.currentIndex = this.currentIndex === 0 
      ? this.slideTargets.length - 1 
      : this.currentIndex - 1
    this.showSlide(this.currentIndex)
  }

  goToSlide(event) {
    const index = parseInt(event.target.dataset.index)
    this.currentIndex = index
    this.showSlide(this.currentIndex)
    this.startAutoplay()
  }

  showSlide(index) {
    // 全てのスライドを非表示
    this.slideTargets.forEach((slide, i) => {
      if (i === index) {
        slide.classList.remove("hidden")
        slide.classList.add("block")
      } else {
        slide.classList.remove("block")
        slide.classList.add("hidden")
      }
    })

    // ドットの状態を更新（元の色を保持）
    this.dotTargets.forEach((dot, i) => {
      if (i === index) {
        // アクティブな状態にする（元の色クラスを保持）
        dot.classList.remove("bg-gray-300")
        // 既存のbg-*クラスを保持（bg-orange-600, bg-blue-600など）
        const activeColorClass = this.getActiveColorClass(dot)
        if (activeColorClass) {
          dot.classList.add(activeColorClass)
        }
      } else {
        // 非アクティブな状態にする
        const activeColorClass = this.getActiveColorClass(dot)
        if (activeColorClass) {
          dot.classList.remove(activeColorClass)
        }
        dot.classList.add("bg-gray-300")
      }
    })
  }

  // ドットの元のアクティブ色クラスを取得
  getActiveColorClass(dot) {
    // data-active-color属性があればそれを使用、なければクラスから推測
    const dataActiveColor = dot.dataset.activeColor
    if (dataActiveColor) {
      return dataActiveColor
    }
    
    // クラスリストからbg-*-*パターンを探す（bg-orange-600, bg-blue-600など）
    const classList = Array.from(dot.classList)
    const activeColorClass = classList.find(cls => 
      cls.match(/^bg-(orange|blue|red|green|purple|yellow|indigo|pink)(-\d+)?$/) && 
      cls !== "bg-gray-300"
    )
    
    return activeColorClass || "bg-blue-600" // デフォルト
  }

  // マウスホバーで自動再生を停止
  mouseEnter() {
    this.stopAutoplay()
  }

  // マウスが離れたら自動再生を再開
  mouseLeave() {
    this.startAutoplay()
  }
}